
import React from 'react';
import InstagramIcon from './icons/InstagramIcon';
import PhoneIcon from './icons/PhoneIcon';
import EmailIcon from './icons/EmailIcon';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-20 bg-[#0a3d34]">
      <div className="container mx-auto px-6 text-center">
        <h2 className="font-serif text-4xl font-bold text-[#f0e1b2] mb-4">Place Your Order</h2>
        <p className="text-lg text-gray-300 max-w-2xl mx-auto mb-8">
          Ready for a taste of Urban Zaikha? Place your delivery or catering order by phone or email. We deliver throughout the Dallas-Fort Worth area.
        </p>

        <div className="max-w-2xl mx-auto mb-12 bg-[#0c1a18] p-4 rounded-lg border-2 border-dashed border-[#d4af37]/50">
          <p className="text-lg font-semibold text-[#f0e1b2]">
            Complimentary delivery on all orders over $15!
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-[#0c1a18]/50 p-8 rounded-lg border border-transparent hover:border-[#d4af37] transition-all duration-300">
            <PhoneIcon className="w-12 h-12 mx-auto mb-4 text-[#d4af37]" />
            <h3 className="font-serif text-xl font-semibold text-white mb-2">Call Us</h3>
            <a href="tel:+19724724770" className="text-lg text-gray-300 hover:text-white">+1 (972) 472-4770</a>
          </div>
          <div className="bg-[#0c1a18]/50 p-8 rounded-lg border border-transparent hover:border-[#d4af37] transition-all duration-300">
            <EmailIcon className="w-12 h-12 mx-auto mb-4 text-[#d4af37]" />
            <h3 className="font-serif text-xl font-semibold text-white mb-2">Email Us</h3>
            <a href="mailto:contact@urbanzaikha.com" className="text-lg text-gray-300 hover:text-white">contact@urbanzaikha.com</a>
          </div>
          <div className="bg-[#0c1a18]/50 p-8 rounded-lg border border-transparent hover:border-[#d4af37] transition-all duration-300">
            <InstagramIcon className="w-12 h-12 mx-auto mb-4 text-[#d4af37]" />
            <h3 className="font-serif text-xl font-semibold text-white mb-2">Follow Us</h3>
            <a href="https://instagram.com/urbanzaikha" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-300 hover:text-white">@urbanzaikha</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
